export type TourSection =
  | 'dashboard'
  | 'analytics'
  | 'courses'
  | 'library'
  | 'microlessons'
  | 'microlessonsList'
  | 'aiHome'
  | 'learners'
  | 'createLearners'
  | 'settingsGeneral';

export const TOUR_SECTIONS: readonly TourSection[] = [
  'dashboard',
  'analytics',
  'courses',
  'library',
  'microlessons',
  'microlessonsList',
  'aiHome',
  'learners',
  'createLearners',
  'settingsGeneral',
];

const STORAGE_PREFIX = 'tourSeen:';
const LEGACY_GLOBAL_KEY = 'globalTourSeen';

const sectionKey = (section: TourSection) => `${STORAGE_PREFIX}${section}`;

const migrateLegacyFlag = () => {
  const legacy = localStorage.getItem(LEGACY_GLOBAL_KEY);
  if (legacy !== 'true') return;
  TOUR_SECTIONS.forEach(section => {
    if (localStorage.getItem(sectionKey(section)) === null) {
      localStorage.setItem(sectionKey(section), 'true');
    }
  });
  localStorage.removeItem(LEGACY_GLOBAL_KEY);
};

export const isTourSectionSeen = (section: TourSection): boolean => {
  migrateLegacyFlag();
  return localStorage.getItem(sectionKey(section)) === 'true';
};

export const markTourSectionSeen = (section: TourSection): void => {
  localStorage.setItem(sectionKey(section), 'true');
};

export const resetAllTourSections = (): void => {
  TOUR_SECTIONS.forEach(section => {
    localStorage.removeItem(sectionKey(section));
  });
  localStorage.removeItem(LEGACY_GLOBAL_KEY);
};

export const markAllTourSectionsSeen = (): void => {
  TOUR_SECTIONS.forEach(section => {
    localStorage.setItem(sectionKey(section), 'true');
  });
};
